import styled from "styled-components";
import { device } from "../../devices";

export const MobileHeaderWrapper = styled.div`
  display: flex;
  width: 100%;
  padding-bottom: 5px;

  @media ${device.mobileScreen} {
    padding: 5px 10px 5px 10px;
  }
`;

export const LogoTypesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const HeaderRightCTA = styled.div.attrs({
  className: "headerRightCTA"
})`
  float: right;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  position: relative;
  height: 6rem;
  margin-left: auto;
  @include mq($wide-screen) {
    height: 5rem;
  }

  .mobileHeaderCrossSale {
    border-left: 0;
  }

  & > div {
    display:flex;
  }

  & .headerLinks,
  .headerCrossSale,
  .header-container-reward{
    border-left: 0;
  }

  & > div.header-rg {
    border-left: unset;
  }

  & .headerLinks {
   @media ${device.maxWideScreen} {
      height: 28px;
      display: flex;
      align-items: center;
    }
  }
}
`;

export const ActionIndicatorWrapper = styled.div`
  z-index: 1;
  @media ${device.desktopScreen} {
    display: flex;
    justify-content: flex-end;
    padding-right: 30px;
    width: 100%;
  }

  @media ${device.mobileScreen} {
    position: absolute;
    right: 100px;
  }
`;
